var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M16.194 4.5a1.315 1.315 0 0 0-.951.384l-.585.604 3.859 3.877.585-.603a1.358 1.358 0 0 0 0-1.92l-1.939-1.94a1.383 1.383 0 0 0-.969-.402zM14 6.018l-.914.878 4.024 4.024.932-.86L14 6.018zm-1.5 1.518L6.171 13.81a.573.573 0 0 0-.293.366l-1.353 4.59a.574.574 0 0 0 .142.572c.148.149.37.203.571.142l4.591-1.354a.573.573 0 0 0 .457-.384l6.237-6.182-.86-.86-6.4 6.42-2.58.75-.549-.549.787-2.688 6.347-6.329-.769-.768zm1.39 1.409l-6.42 6.438.933.2.128.86 6.439-6.42-1.08-1.078z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1461681d5fa5d6bab7c076f76f5f4755.svg";
export { ForwardRef as ReactComponent };